import { render, staticRenderFns } from "./SupportPackageTabs.vue?vue&type=template&id=2810ce96&scoped=true"
import script from "./SupportPackageTabs.vue?vue&type=script&lang=js"
export * from "./SupportPackageTabs.vue?vue&type=script&lang=js"
import style0 from "./SupportPackageTabs.vue?vue&type=style&index=0&id=2810ce96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810ce96",
  null
  
)

export default component.exports